module.exports = __webpack_public_path__ + "img/curve_2@2x.cad2b8d3.png";